import { AccessGrant, VisitorGroup } from 'graphql/generated/graphqlTypes';
import { visitorGroupsWithIsOfficeModeEnabledVar } from 'state/vars';

export const setIsOfficeModeEnabledAction = (visitorGroups: VisitorGroup[]) => {
  visitorGroupsWithIsOfficeModeEnabledVar(visitorGroups);
};

export const updateAccessGrantsArrayWithIsOfficeModeEnabled = (
  updatedAccessGrantId: string | null,
  accessGrants: AccessGrant[]
) =>
  accessGrants.map((accessGrant) =>
    accessGrant.id === updatedAccessGrantId
      ? { ...accessGrant, isOfficeModeEnabled: !accessGrant.isOfficeModeEnabled }
      : accessGrant
  );

export const updateIsOfficeModeEnabledAction = (updatedAccessGrantId: string | null) => {
  const currentVisitorGroupsWithIsOfficeModeEnabled = visitorGroupsWithIsOfficeModeEnabledVar();
  const updatedVisitorGroups = currentVisitorGroupsWithIsOfficeModeEnabled.map((group) => ({
    ...group,
    accessGrants: updateAccessGrantsArrayWithIsOfficeModeEnabled(updatedAccessGrantId, group.accessGrants)
  }));

  visitorGroupsWithIsOfficeModeEnabledVar(updatedVisitorGroups);
};
